import { render, staticRenderFns } from "./SaveCard.vue?vue&type=template&id=3832447a&scoped=true"
import script from "./SaveCard.vue?vue&type=script&lang=js"
export * from "./SaveCard.vue?vue&type=script&lang=js"
import style0 from "./SaveCard.vue?vue&type=style&index=0&id=3832447a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832447a",
  null
  
)

export default component.exports